module.exports = __webpack_public_path__ + "img/preview.2d104713.webp";